// Configuration for backend URL
// Uses custom domains for production, falls back to environment or local for development
const getBackendURL = () => {
  return process.env.REACT_APP_BACKEND_URL || 'https://api.lastcard.hparpia.com';
};

const getWSURL = () => {
  return process.env.REACT_APP_WS_URL || 'wss://api.lastcard.hparpia.com';
};

// Detect if we're on mobile
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

const BACKEND_URL = getBackendURL();
let WS_URL;

if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
  WS_URL = 'ws://localhost:8000';
} else {
  // Use secure WebSocket for production
  WS_URL = 'wss://api.lastcard.hparpia.com';
}

// For development, you can change these URLs:
// const BACKEND_URL = 'http://localhost:8000';
// const WS_URL = 'ws://localhost:8000';

export { BACKEND_URL, WS_URL, isMobile }; 